<template>
    <div class="thread thread_review">

        <div class="comment">

            <div class="comment__header">
                <a v-if="authUser" href="#" class="btn btn--sm btn--round" @click.prevent="showCommentForm = !showCommentForm">Добавить комментарий</a>
                <a v-else href="/auth/login" class="btn btn--sm btn--round">Добавить комментарий</a>
            </div>

            <transition name="slide">

                <comments-form :type="type" :object="object" :reply="null" @refresh-comments="getComments(page = 1)" v-show="showCommentForm" />

            </transition>

        </div>

        <template v-if="list.length">
            <div class="media-list thread-list">
                <div class="single-thread">

                    <comments-recursive :type="type" :object="object" @refresh-comments="getComments(page)"
                                        :_node="_node" v-for="( _node, _idx ) in list" :key="_node.id" :show-form="true" />

                </div>
            </div>
            <!-- end /.media-list -->

            <div class="pagination-area mb-5 pb-3" v-if="lastPage > 1">
                <button
                    class="pagination-area__btn"
                    :disabled="page === 1"
                    @click="getComments( --page )">
                    <span class="lnr lnr-arrow-left"></span>
                </button>
                <button
                    class="pagination-area__btn"
                    :disabled="page >= lastPage"
                    @click="getComments( ++page )">
                    <span class="lnr lnr-arrow-right"></span>
                </button>
            </div>
        </template>
        <template v-else>
            <div class="tab-empty d-flex">Будь первым, кто оставит комментарий!</div>
        </template>
        <!-- end /.comment pagination area -->
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import CommentsRecursive from './PetAndProjectRecursiveComments';
import CommentsForm from './PetAndProjectCommentForm';

export default {
    name: "PetAndProjectThanksTabComponent",
    components: { CommentsRecursive, CommentsForm },
    data() {
        return {

            showCommentForm: false,

            thanksList: [],
            moment: window.moment,

            list: [],
            page: 1,
            lastPage: null,
        };
    },
    props: ['object', 'type'],

    async mounted() {
        await this.getComments( this.page );
    },

    computed: {

        ...mapGetters({
            authUser: 'getUserData'
        }),

    },

    methods: {

        getUserPM(name) {
            if (!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

        async getComments( _page = 1 ){

            let params = { page: _page, per_page: 5 };

            try{

                const {
                        data: {
                            data = [], last_page = 0,
                            extended_data: { success } = { success: false }, // default value extended_data = { success: false }
                            ...rest
                        } // response.data
                }  =  await axios.get( `/api/${this.type}s/${this.object.id}/comments`, { params: params } );

                if( success ) {

                    this.list = data;
                    this.lastPage = last_page;
                }


            } catch ( _e ) {

                console.log( _e );

            }


        }

    },



}
</script>

<style lang="scss" scoped>

.comment{
    padding: 15px;

    &__header{
        text-align: right;
    }
}

.pagination-area {
    padding: 15px 0;
}

.pagination-area__btn {
    background: #ececec;
    border: none;
    line-height: 30px;
    width: 30px;
    height: 30px;
    box-shadow: none;
    border-radius: 50%;
    text-align: center;
    margin: 0 5px;
}

.pagination-area__btn span {
    vertical-align: middle;
}

.tab-empty {
    justify-content: center;
    align-items: center;
    height: 200px;
    padding: 10px;
    text-align: center;
}

.thread::v-deep .thread-list .single-thread{

    .media{
        position: relative;
        flex-direction: column;
        border-bottom: 1px solid #ececec;
        align-items: stretch;
        &:last-child{
            border-bottom: none;
        }

    }

    .media-content{
        position: relative;
    }

    .actions {
        justify-content: space-between;
        width: 100%;
        align-items: center;
        .btn{
            margin-left: auto;
        }

    }


    .remove-btn{
        position: absolute;
        top: -5px;
        right: -15px;
        display: inline-block;
        padding: 5px;
        transition: opacity .2s ease;


        &:hover{
            opacity: .8;
        }

    }

    .media-more{
        text-align: center;
        cursor: pointer;
        color: #9d9d9d;
        font-size: 12px;
        margin-top: 5px;
        transition: opacity .2s ease;


        &:hover{
            opacity: .8;
        }

        &--open{
            color: #333;
        }

    }




    .media-left {
        padding: 0;
        margin-right: 19px;
        position: relative;
        height: 50px;
        width: 50px;
        min-width: 50px;
        line-height: 50px;
        color: #fff;
        font-size: 18px;
        text-align: center;
        border-radius: 50%;
        overflow: hidden;
    }

    .media-left a {
        width: 100%;
        height: auto;
    }


   .media-left .media-object {
        position: relative;
        width: 100%;
        height: auto;
        vertical-align: unset;
        z-index: 2;
    }

    .media-left__name {
        position: absolute;
        left: 1px;
        bottom: 1px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        z-index: 1;
        background: #2E76E4;

    }

    .media-body {
        color: #929292;
        font-size: 14px;
        line-height: 18px;
    }

    .text-black {
        color: #333;
    }

    .media-heading {
        margin-bottom: 10px;
    }

    .text-blue {
        color: #007bff;
    }

    .media-heading a {

        transition: opacity .2s ease;

        &:hover {
            opacity: .8;
        }
    }

    .media-heading__comment {
        padding-top: 0 !important;
        margin-bottom: 15px !important;
    }

    span.time {
        font-size: 12px;
        line-height: 15px;
        color: #929292;
    }


    .second-level{
        padding: 15px 0 15px 45px;
        border: none;

        .media-left{
            height: 30px;
            width: 30px;
            min-width: 30px;
            font-size: 12px;
        }

        .media-left__name{
            width: 28px;
            height: 28px;
            color: #fff;
        }

        .remove-btn{
            right: 5px;
        }

        & > .second-level {
            padding-left: 0;
        }

        &:last-child{
            border-bottom: none;
            padding-bottom: 0;
        }

    }


    @media screen and(max-width: 768px) {
        .media {
            flex-direction: column;
            align-items: center;
            padding: 30px 15px 26px;

            &.second-level{
                padding: 8px 0;
                width: 100%;
            }

        }

        .media-left {
            padding-right: 0;
            margin-bottom: 20px;
            margin-right: 0;
        }

        .media-heading__name{
            display: flex;
            flex-direction: column;
            align-items: center;
            span.time{
                margin-left: 0;
            }
        }

        .remove-btn{
            right: 0;
        }

        .actions{
            flex-direction: column;

            .btn{
                margin-left: unset;
                margin-top: 10px;
            }

        }

        .media-body {
            text-align: center;
        }


        .comment__header{
            text-align: center;
        }

        .media-content{
            flex-direction: column;
            align-items: center;
            width: 100%;
        }

        .thread .media-more{
            padding: 10px;
        }


    }


}

</style>
